import { render, staticRenderFns } from "./FrontOrder.vue?vue&type=template&id=1677f034&"
import script from "./FrontOrder.vue?vue&type=script&lang=js&"
export * from "./FrontOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports